import { HomeStage } from '../HomePage/HomeStage'

export default function UIPage() {
  return <HomeStage />
}
